import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

export const trainingRoutes: Routes = [
  {
    path: 'training-center',
    loadComponent: () =>
      import('@pages/common/training-center/training-center').then(
        (m) => m.TrainingCenter
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            '@pages/common/training-center/training-home/training-home'
          ).then((m) => m.TrainingHome),
      },
      {
        path: 'allVideos',
        loadComponent: () =>
          import('@pages/common/training-center/all-videos/all-videos').then(
            (m) => m.AllVideos
          ),
      },
      {
        path: 'allDocs',
        loadComponent: () =>
          import('@pages/common/training-center/all-docs/all-docs').then(
            (m) => m.AllDocs
          ),
      },
    ],
  },
  {
    path: 'training-center/video/:id',
    loadComponent: () =>
      import('@pages/common/training-center/training-vid/training-vid').then(
        (m) => m.TrainingVid
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
];
